import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxauthService } from 'src/app/dxauth.service';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';

@Component({
  selector: 'app-doctors-next-register-resend',
  templateUrl: './doctors-next-register-resend.component.html',
  styleUrls: [
    './doctors-next-register-resend.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextRegisterResendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  email: string = '';
  constructor(
    private dxauth: DxauthService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
    this.activatedRoute.queryParams.subscribe((query) => {
      this.clientId = query['client_id'];
    });
  }

  ngOnInit(): void {}

  get isSubmitable() {
    if (!this.email.length) return false;
    if (this.email) {
      const match = this.email.match(/^.*@.*\..+$/);
      return match;
    }
    return true;
  }
  async submit() {
    if (!this.isSubmitable) return;
    this.spinner.show();
    try {
      await this.dxauth.resendInviteEmail({
        clientId: this.clientId,
        email: this.email,
      });
      location.pathname = 'register-send';
    } catch (error) {
    } finally {
      this.spinner.hide();
    }
  }
}
